import { useCallback } from 'react';

import { useAppContext } from '../../../common/ui/app-context';
import {
	type CopyLinkButtonClickedArgs,
	onCopyLinkButtonClicked,
} from '../../../common/utils/events/copy-link-button-clicked';
import { serveSearchPageRelayExp } from '../../../common/utils/experiments';
import { getExtensionData } from '../../../common/utils/relay/get-extension-data';
import { useAnalytics, useCommonAndPrivateAttributes } from '../../analytics';
import { usePrimaryProduct } from '../../store/bootstrap/accessors';

/**
 * @returns a callback to fire an event when the result
 * is clicked by the user.
 */
export const useFireCopyLinkButtonClicked = (location: CopyLinkButtonClickedArgs['location']) => {
	const { fireAnalyticsEvent } = useAnalytics();
	const { commonAttributes, nonPrivacySafeAttributes } = useCommonAndPrivateAttributes();
	const [primaryProduct] = usePrimaryProduct();
	const { queryParams } = useAppContext();

	return useCallback(() => {
		fireAnalyticsEvent(
			onCopyLinkButtonClicked({
				commonAttributes: {
					...commonAttributes,
					...(primaryProduct && serveSearchPageRelayExp(primaryProduct, false, queryParams)
						? getExtensionData(commonAttributes.isCQL)
						: {}),
				},
				nonPrivacySafeAttributes,
				location,
			}),
		);
	}, [
		fireAnalyticsEvent,
		commonAttributes,
		nonPrivacySafeAttributes,
		location,
		primaryProduct,
		queryParams,
	]);
};
